import {RouteConfig} from "vue-router";
import Error404 from "@/views/errors/404.vue";

// MasterLayout
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

// Register
import registerRoutes from "./register";
import defaultRoutes from "./default";
import departmentRoutes from "./department";
import serviceRoutes from "./services";
import Home from "@/views/Home.vue";
import organizationRoutes from "./organization";
import permissionRoutes from "./permission";
import rolesRoutes from "./roles";
import reportRoutes from "./report";
import customRoutesPermissionRoutes from "./customRoutesPermission";
import databaseConnectionRoutes from "./databaseConnection";

// CBS Routes
import CBSAPIGatewayRoutes from "./CBSApiGateway"
import CBSAccountingRoutes from "./CBSAccounting"
import CBSCommissionRoutes from "./CBSCommission"
import CBSPaymentRoutes from "./CBSPayment"
import CBSProductRoutes from "./CBSProduct"
import operationalLogs from "./operational_logs"
import CBSProductRatingRoutes from "./CBSProductRating"
import CBSUserManagementRoutes from "./CBSUserManagement"
import CBSSubscriptionRoutes from "./CBSSubscription"
import CBSInvoice from "./CBSInvoice"

// EW Routes
import EWTransactions from './EWTransactions'

// @ts-ignore
const baseRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin",
    name: "HomeAdmin",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users",
    name: "Users",
    component: () => import("../views/User/UserList.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/add",
    name: "UserAdd",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/edit/:id",
    name: "UserEdit",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/view/:id",
    name: "UserView",
    component: () => import("../views/User/UserView.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/:id/subscriptions",
    name: "UserSubscriptions",
    component: () => import("../views/User/UserSubscription.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/profile",
    name: "AuthProfile",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications",
    name: "AuthNotifications",
    component: () => import("../views/User/AuthNotifications.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications/:id/show",
    name: "AuthNotificationShow",
    component: () => import("../views/User/AuthNotificationShow.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/update-password",
    name: "AuthChangePassword",
    component: () => import("../views/User/UpdatePassword.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/ext/change-password",
    name: "UserPasswordReset",
    component: () => import("../views/User/UserPasswordReset.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },

  {
    path: "/admin/ew_user_details",
    name: "EWUserDetailList",
    component: () => import("../views/EWUserDetail/EWUserDetailList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_balance",
    name: "EWUserBalanceList",
    component: () => import("../views/EWUserDetail/EWUserBalanceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_details/add",
    name: "EWUserDetailAdd",
    component: () => import("../views/EWUserDetail/EWUserDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_details/:id/edit",
    name: "EWUserDetailEdit",
    component: () => import("../views/EWUserDetail/EWUserDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_details/:id/show",
    name: "EWUserDetailShow",
    component: () => import("../views/EWUserDetail/EWUserDetailShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/ew_user_pending_details",
    name: "EWUserPendingDetailList",
    component: () => import("../views/EWUserPendingDetail/EWUserPendingDetailList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_pending_details/add",
    name: "EWUserPendingDetailAdd",
    component: () => import("../views/EWUserPendingDetail/EWUserPendingDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_pending_details/:id/edit",
    name: "EWUserPendingDetailEdit",
    component: () => import("../views/EWUserPendingDetail/EWUserPendingDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_pending_details/:id/show",
    name: "EWUserPendingDetailShow",
    component: () => import("../views/EWUserPendingDetail/EWUserPendingDetailShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_config_logs",
    name: "EWLimitConfigLogList",
    component: () => import("../views/EWLimitConfigLog/EWLimitConfigLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_config_logs/add",
    name: "EWLimitConfigLogAdd",
    component: () => import("../views/EWLimitConfigLog/EWLimitConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_config_logs/:id/edit",
    name: "EWLimitConfigLogEdit",
    component: () => import("../views/EWLimitConfigLog/EWLimitConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_config_logs/:id/show",
    name: "EWLimitConfigLogShow",
    component: () => import("../views/EWLimitConfigLog/EWLimitConfigLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_configs",
    name: "EWLimitConfigList",
    component: () => import("../views/EWLimitConfig/EWLimitConfigList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_configs/add",
    name: "EWLimitConfigAdd",
    component: () => import("../views/EWLimitConfig/EWLimitConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_configs/:id/edit",
    name: "EWLimitConfigEdit",
    component: () => import("../views/EWLimitConfig/EWLimitConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_configs/:id/show",
    name: "EWLimitConfigShow",
    component: () => import("../views/EWLimitConfig/EWLimitConfigShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_limit_configs/:id/logs",
    name: "EWLimitConfigLogs",
    component: () => import("../views/EWLimitConfig/EWLimitConfigLogs.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/countries",
    name: "CountryList",
    component: () => import("../views/Country/CountryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/countries/add",
    name: "CountryAdd",
    component: () => import("../views/Country/CountryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/countries/:id/edit",
    name: "CountryEdit",
    component: () => import("../views/Country/CountryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/countries/:id/show",
    name: "CountryShow",
    component: () => import("../views/Country/CountryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cities",
    name: "CityList",
    component: () => import("../views/City/CityList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cities/add",
    name: "CityAdd",
    component: () => import("../views/City/CityForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cities/:id/edit",
    name: "CityEdit",
    component: () => import("../views/City/CityForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cities/:id/show",
    name: "CityShow",
    component: () => import("../views/City/CityShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_countries",
    name: "EWCountryList",
    component: () => import("../views/EWCountry/EWCountryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_countries/add",
    name: "EWCountryAdd",
    component: () => import("../views/EWCountry/EWCountryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_countries/:id/edit",
    name: "EWCountryEdit",
    component: () => import("../views/EWCountry/EWCountryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_countries/:id/show",
    name: "EWCountryShow",
    component: () => import("../views/EWCountry/EWCountryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_cities",
    name: "EWCityList",
    component: () => import("../views/EWCity/EWCityList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_cities/add",
    name: "EWCityAdd",
    component: () => import("../views/EWCity/EWCityForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_cities/:id/edit",
    name: "EWCityEdit",
    component: () => import("../views/EWCity/EWCityForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_cities/:id/show",
    name: "EWCityShow",
    component: () => import("../views/EWCity/EWCityShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_histories",
    name: "EWTrxHistoryList",
    component: () => import("../views/EWTrxHistory/EWTrxHistoryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_histories/add",
    name: "EWTrxHistoryAdd",
    component: () => import("../views/EWTrxHistory/EWTrxHistoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_histories/:id/edit",
    name: "EWTrxHistoryEdit",
    component: () => import("../views/EWTrxHistory/EWTrxHistoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_histories/:id/show",
    name: "EWTrxHistoryShow",
    component: () => import("../views/EWTrxHistory/EWTrxHistoryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_types",
    name: "EWTrxActivityTypeList",
    component: () => import("../views/EWTrxActivityType/EWTrxActivityTypeList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_types/add",
    name: "EWTrxActivityTypeAdd",
    component: () => import("../views/EWTrxActivityType/EWTrxActivityTypeForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_types/:id/edit",
    name: "EWTrxActivityTypeEdit",
    component: () => import("../views/EWTrxActivityType/EWTrxActivityTypeForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_types/:id/show",
    name: "EWTrxActivityTypeShow",
    component: () => import("../views/EWTrxActivityType/EWTrxActivityTypeShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/configuration",
    name: "ConfigurationForm",
    component: () => import("../views/Configuration/ConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/user_limit_update/:id",
    name: "UserLimitUpdateConfig",
    component: () => import("../views/Configuration/UserLimitUpdateConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  , {
    path: "/admin/ew_config_logs",
    name: "EWConfigLogList",
    component: () => import("../views/EWConfigLog/EWConfigLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_config_logs/add",
    name: "EWConfigLogAdd",
    component: () => import("../views/EWConfigLog/EWConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_config_logs/:id/edit",
    name: "EWConfigLogEdit",
    component: () => import("../views/EWConfigLog/EWConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_config_logs/:id/show",
    name: "EWConfigLogShow",
    component: () => import("../views/EWConfigLog/EWConfigLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config",
    name: "EWUserConfigList",
    component: () => import("../views/EWUserConfig/EWUserConfigList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config/add",
    name: "EWUserConfigAdd",
    component: () => import("../views/EWUserConfig/EWUserConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config/:id/edit",
    name: "EWUserConfigEdit",
    component: () => import("../views/EWUserConfig/EWUserConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config/:id/show",
    name: "EWUserConfigShow",
    component: () => import("../views/EWUserConfig/EWUserConfigShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config_logs",
    name: "EWUserConfigLogList",
    component: () => import("../views/EWUserConfigLog/EWUserConfigLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config_logs/add",
    name: "EWUserConfigLogAdd",
    component: () => import("../views/EWUserConfigLog/EWUserConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config_logs/:id/edit",
    name: "EWUserConfigLogEdit",
    component: () => import("../views/EWUserConfigLog/EWUserConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_config_logs/:id/show",
    name: "EWUserConfigLogShow",
    component: () => import("../views/EWUserConfigLog/EWUserConfigLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_type_logs",
    name: "EWTrxActivityTypeLogList",
    component: () => import("../views/EWTrxActivityTypeLog/EWTrxActivityTypeLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_type_logs/add",
    name: "EWTrxActivityTypeLogAdd",
    component: () => import("../views/EWTrxActivityTypeLog/EWTrxActivityTypeLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_type_logs/:id/edit",
    name: "EWTrxActivityTypeLogEdit",
    component: () => import("../views/EWTrxActivityTypeLog/EWTrxActivityTypeLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_trx_activity_type_logs/:id/show",
    name: "EWTrxActivityTypeLogShow",
    component: () => import("../views/EWTrxActivityTypeLog/EWTrxActivityTypeLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limits",
    name: "EWUserActivityLimitList",
    component: () => import("../views/EWUserActivityLimit/EWUserActivityLimitList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limits/add",
    name: "EWUserActivityLimitAdd",
    component: () => import("../views/EWUserActivityLimit/EWUserActivityLimitForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limits/:id/edit",
    name: "EWUserActivityLimitEdit",
    component: () => import("../views/EWUserActivityLimit/EWUserActivityLimitForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limits/:id/show",
    name: "EWUserActivityLimitShow",
    component: () => import("../views/EWUserActivityLimit/EWUserActivityLimitShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limit_logs",
    name: "EWUserActivityLimitLogList",
    component: () => import("../views/EWUserActivityLimitLog/EWUserActivityLimitLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limit_logs/add",
    name: "EWUserActivityLimitLogAdd",
    component: () => import("../views/EWUserActivityLimitLog/EWUserActivityLimitLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limit_logs/:id/edit",
    name: "EWUserActivityLimitLogEdit",
    component: () => import("../views/EWUserActivityLimitLog/EWUserActivityLimitLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_activity_limit_logs/:id/show",
    name: "EWUserActivityLimitLogShow",
    component: () => import("../views/EWUserActivityLimitLog/EWUserActivityLimitLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_config_logs",
    name: "EWUserLimitConfigLogList",
    component: () => import("../views/EWUserLimitConfigLog/EWUserLimitConfigLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_config_logs/add",
    name: "EWUserLimitConfigLogAdd",
    component: () => import("../views/EWUserLimitConfigLog/EWUserLimitConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_config_logs/:id/edit",
    name: "EWUserLimitConfigLogEdit",
    component: () => import("../views/EWUserLimitConfigLog/EWUserLimitConfigLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_config_logs/:id/show",
    name: "EWUserLimitConfigLogShow",
    component: () => import("../views/EWUserLimitConfigLog/EWUserLimitConfigLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_configs",
    name: "EWUserLimitConfigList",
    component: () => import("../views/EWUserLimitConfig/EWUserLimitConfigList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_configs/add",
    name: "EWUserLimitConfigAdd",
    component: () => import("../views/EWUserLimitConfig/EWUserLimitConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_configs/:id/edit",
    name: "EWUserLimitConfigEdit",
    component: () => import("../views/EWUserLimitConfig/EWUserLimitConfigForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_limit_configs/:id/show",
    name: "EWUserLimitConfigShow",
    component: () => import("../views/EWUserLimitConfig/EWUserLimitConfigShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_frequencies",
    name: "EWFrequencyList",
    component: () => import("../views/EWFrequency/EWFrequencyList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_frequencies/add",
    name: "EWFrequencyAdd",
    component: () => import("../views/EWFrequency/EWFrequencyForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_frequencies/:id/edit",
    name: "EWFrequencyEdit",
    component: () => import("../views/EWFrequency/EWFrequencyForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_frequencies/:id/show",
    name: "EWFrequencyShow",
    component: () => import("../views/EWFrequency/EWFrequencyShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  //##Routes##//
  {
    path: "/admin/ew_news",
    name: "EWNewsList",
    component: () => import("../views/EWNews/EWNewsList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_news/add",
    name: "EWNewsAdd",
    component: () => import("../views/EWNews/EWNewsForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_news/:id/edit",
    name: "EWNewsEdit",
    component: () => import("../views/EWNews/EWNewsForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_news/:id/show",
    name: "EWNewsShow",
    component: () => import("../views/EWNews/EWNewsShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_user_device_info",
    name: "EWUserDeviceInfoList",
    component: () => import("../views/EWUserDeviceInfo/EWUserDeviceInfoList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  //pending
  {
    path: "/admin/ew_merchant_registration_requests",
    name: "EWMerchantRegistrationRequestList",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantPending/EWMerchantRegistrationRequestList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests/:id/edit",
    name: "EWMerchantRegistrationRequestForm",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantPending/EWMerchantRegistrationRequestForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests/:id/show",
    name: "EWMerchantRegistrationRequestShow",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantPending/EWMerchantRegistrationRequestShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  //approved
  {
    path: "/admin/ew_merchant_registration_requests_approved",
    name: "EWMerchantRegistrationApprovedList",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantApproved/EWMerchantRegistrationApprovedList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests_approved/:id/edit",
    name: "EWMerchantRegistrationApprovedForm",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantApproved/EWMerchantRegistrationApprovedForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests_approved/:id/show",
    name: "EWMerchantRegistrationApprovedShow",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantApproved/EWMerchantRegistrationApprovedShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  //rejected
  {
    path: "/admin/ew_merchant_registration_requests_rejected",
    name: "EWMerchantRegistrationRejectList",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantRejected/EWMerchantRegistrationRejectedList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests_rejected/:id/edit",
    name: "EWMerchantRegistrationRejectForm",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantRejected/EWMerchantRegistrationRejectedForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ew_merchant_registration_requests_rejected/:id/show",
    name: "EWMerchantRegistrationRejectShow",
    component: () => import("../views/EWMerchantRegistrationRequest/EWMerchantRejected/EWMerchantRegistrationRejectedShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

];

const routes = baseRoutes.concat(
  registerRoutes,
  defaultRoutes,
  departmentRoutes,
  serviceRoutes,
  organizationRoutes,
  permissionRoutes,
  rolesRoutes,
  operationalLogs,
  reportRoutes,
  customRoutesPermissionRoutes,
  databaseConnectionRoutes,

  // CBS Routes
  CBSAPIGatewayRoutes,
  CBSAccountingRoutes,
  CBSCommissionRoutes,
  CBSPaymentRoutes,
  CBSProductRoutes,
  CBSProductRatingRoutes,
  CBSUserManagementRoutes,
  CBSSubscriptionRoutes,
  CBSInvoice,

  // EW Routes
  EWTransactions
)

export default routes
